<template>
    <div id="check-protocol-container">
        <veui-checkbox v-model="checkProtocol" theme="ai"/>
        <span class="check-protocol-text">我已阅读并同意</span>
        <veui-button
            ui="text strong"
            theme="ai"
            @click="handleClick"
        >
            《擎舵平台用户服务协议》
        </veui-button>
    </div>
</template>

<script>
import {Checkbox, Button} from 'veui';
import {platformProtocolPath} from '@/config/default';
export default {
    name: 'CheckProtocol', // 组件名称
    components: {
        'veui-checkbox': Checkbox,
        'veui-button': Button

    },
    watch: {
        checkProtocol(val) {
            window.isCheckProtocol = val;
        }
    },
    data() {
        return {
            checkProtocol: false
        };
    },
    methods: {
        handleClick() {
            const {protocol, host} = window.location;
            const prefix = `${protocol}//${host}`;
            const url = `${prefix}${platformProtocolPath}`;
            window.open(url, '_blank', 'noreferrer');
        }
    }
};
</script>

<style lang="less" scoped>
#check-protocol-container {
    display: flex;
    align-items: center;
    height: 20px;
    font-size: 14px;
    line-height: 20px; /* 142.857% */
    .check-protocol-text {
        color: var(---G7, #848B99);
        margin-right: 4px;
        margin-left: 8px;

    }
}
</style>